import IndividualTable from "../../../IndividualTable";
import { sampleData2 } from "../../sampleData";

const Distance30 = () => {
  let winners = ["327"];
  return <IndividualTable matchType={"3"} gender="F" event="30" subTitle="Zamby" data={sampleData2} topRankCount="1" winners={winners} />;
};
export default Distance30;
